import React, { useMemo } from 'react';
import classNames from 'classnames';
import { getLanguage } from '@home/utils/common';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import './index.scss';

export interface ISectionHeadingWithSubProps {
  className?: string;
  style?: React.CSSProperties;
  /** 与 titleCn / titleEn 二选一：直接传入已选好的文案 */
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  titleEn?: string;
  titleCn?: string;
  subTitleEn?: string;
  subTitleCn?: string;
}

/**
 * 区块标题：左侧橙色竖线 + 主标题 + 右侧副标题（较小、灰色）
 */
const SectionHeadingWithSub: React.FC<ISectionHeadingWithSubProps> = ({
  className,
  style,
  title,
  subTitle,
  titleEn,
  titleCn,
  subTitleEn,
  subTitleCn,
}) => {
  const { isEN } = useLocal();

  const titleNode = useMemo(() => {
    if (title !== undefined && title !== null && title !== '') {
      return title;
    }
    if (titleEn != null || titleCn != null) {
      return getLanguage(isEN, titleEn ?? '', titleCn ?? '');
    }
    return null;
  }, [isEN, title, titleEn, titleCn]);

  const subTitleNode = useMemo(() => {
    if (subTitle !== undefined && subTitle !== null && subTitle !== '') {
      return subTitle;
    }
    if (subTitleEn != null || subTitleCn != null) {
      return getLanguage(isEN, subTitleEn ?? '', subTitleCn ?? '');
    }
    return null;
  }, [isEN, subTitle, subTitleEn, subTitleCn]);

  if (titleNode == null && subTitleNode == null) {
    return null;
  }

  return (
    <div
      className={classNames('dbd-section-heading-with-sub', className)}
      style={style}
    >
      {titleNode != null && (
        <span className="dbd-section-heading-with-sub__main">{titleNode}</span>
      )}
      {subTitleNode != null && (
        <span className="dbd-section-heading-with-sub__sub">{subTitleNode}</span>
      )}
    </div>
  );
};

export default SectionHeadingWithSub;
